import React, {useCallback} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {CommunityGetSchema} from '../../../../api/DBSchema/Community';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import SMCLink from '../../../../components/Simple/SMCLink';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {push} from 'connected-react-router';
import SMCIcon from '../../../../components/Simple/SMCIcon';

const pageSchema = CommunityGetSchema;

function CommunityGeneral({
    communityObject,
    setCommunityData,
    navigateTo
}) {
    const { t } = useTranslation();

    const pageData = communityObject;
    const setPageValue = useCallback((paramName, value) => {
        setCommunityData(paramName, value);
    }, [setCommunityData]);

    const description                = pageData[pageSchema.description];
    const parentCommunity            = pageData[pageSchema.parentCommunity];
    const availableParentCommunities = pageData[pageSchema.availableParentCommunities];

    return (
        <EditorLayout>
            <SMCTextInput
                value={description}
                onChange={e => setPageValue(pageSchema.description, e.target.value)}
                label={t('SMP.DESCRIPTION')}
            />
            <RowLayout spacing="4px">
                <SMCSelect
                    value={parentCommunity}
                    onChange={e => setPageValue(pageSchema.parentCommunity, e.target.value)}
                    label={t('SMP.COMMUNITIES.TABLE.GENERAL.PARENT_COMMUNITY')}
                    tooltip={t('SMP.COMMUNITIES.TABLE.GENERAL.PARENT_COMMUNITY.TOOLTIP')}
                >
                    <SMCOption value="" />
                    {
                        availableParentCommunities && (
                            availableParentCommunities.map(comm => <SMCOption key={comm} value={comm}>{comm}</SMCOption>)
                        )
                    }
                </SMCSelect>
                <SMCLink
                    disabled={!parentCommunity}
                    underline
                    onClick={() => navigateTo({search: 'id=' + parentCommunity})}
                >
                    <SMCIcon icon="rightArrow" /> {t('SMC_GEN_GO')}
                </SMCLink>
            </RowLayout>

        </EditorLayout>
    )
}

const mapStateToProps = null;

const mapDispatchToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityGeneral);